import type { ScopedThreadRef, ServerProviderSkill } from "@t3tools/contracts";
import { memo } from "react";
import ChatMarkdown from "../ChatMarkdown";

interface AssistantMessageContentProps {
  readonly text: string | null | undefined;
  readonly cwd: string | undefined;
  readonly threadRef: ScopedThreadRef | undefined;
  readonly isStreaming: boolean;
  readonly skills: ReadonlyArray<Pick<ServerProviderSkill, "name" | "displayName">>;
}

export const AssistantMessageContent = memo(function AssistantMessageContent({
  text,
  cwd,
  threadRef,
  isStreaming,
  skills,
}: AssistantMessageContentProps) {
  return (
    <ChatMarkdown
      text={text || (isStreaming ? "" : "(empty response)")}
      cwd={cwd}
      threadRef={threadRef}
      isStreaming={isStreaming}
      skills={skills}
      presentation="conversation-assistant"
    />
  );
});
